module.exports = __webpack_public_path__ + "img/user-avatar0.5047c019.png";